import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TrackClickDirective } from './track-click/track-click.directive';
import { TrackInputDirective } from './track-input/track-input.directive';
import { TrackFormDirective } from './track-form/track-form.directive';
import { TrackControlDirective } from './track-control/track-control.directive';

// Firebase app/analytics providers are registered once, at the root, in
// app.module.ts — not here. This module is imported by many lazy-loaded
// feature modules (through SharedModule), and each lazy module gets its
// own child injector; registering provideFirebaseApp()/provideAnalytics()
// on this module would re-run initializeApp() in every one of those injectors.
@NgModule({
  declarations: [
    TrackClickDirective,
    TrackInputDirective,
    TrackFormDirective,
    TrackControlDirective,
  ],
  imports: [CommonModule],
  exports: [
    TrackClickDirective,
    TrackInputDirective,
    TrackFormDirective,
    TrackControlDirective,
  ],
})
export class AhoyAnalyticsModule {}
